// extracted by mini-css-extract-plugin
module.exports = {"character":"AvatarMessage_character__Wgb6I","avatarContainer":"AvatarMessage_avatarContainer__S692_","avatarMessage":"AvatarMessage_avatarMessage__Mko65"};